export default __webpack_public_path__ + "860305051830e02ac20b24b8b604d3ad.svg";